import React from 'react';
import { Container, Row } from 'react-bootstrap';
import { withAuthorization } from '../Session';
import AllList from './AllList';

class Notifications extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Container>
                <Row>
                    <h4 style={{ marginLeft: '1rem', marginRight: '1rem' }}>
                        Manage Notifications
                    </h4>
                </Row>
                <div>
                    <hr />
                </div>

                <AllList {...this.props} userRole={this.props.role} />
            </Container>
        );
    }
}

const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(Notifications);
